<div class=" order_sum_wrapper ">
    <fieldset class="scheduler-border">
        <legend class="scheduler-border">Order Search Criteria</legend>
        <div class="col-md-12">
            <form (ngSubmit)="getOrders(1)" #searchOrder="ngForm" autocomplete="off">
                <div class="row">
                    <div class="col-12 col-sm-4 col-md-2 col-lg-2 order_sum_col">
                        <div class="form-group has-feedback">
                            <label for="dateFrom" class="control-label">Date From:</label>
                            <!-- <input type="text" class="form-control" placeholder="Date From" id="dateFrom"
                                name="dateFrom" [(ngModel)]="orderSearchCriteria.DateFrom" style="cursor: pointer;"
                                readonly required /> -->
                            <div class="input-group">
                                <input class="form-control" id="dateFrom" name="dateFrom" [(ngModel)]="DateFrom" (click)="dateFrom.toggle()" ngbDatepicker #dateFrom="ngbDatepicker" style="cursor: pointer;" [maxDate]="DateTo" readonly required>
                                <!-- <button class="btn btn-outline-secondary calendar" (click)="dateFrom.toggle()"
                                    type="button"></button> -->
                                <i (click)="dateFrom.toggle()" class="fa fa-calendar " aria-hidden="true" style="position: absolute;right: 6px;top: 5px;z-index: 9;"></i>
                            </div>


                        </div>
                    </div>
                    <div class="col-12 col-sm-4 col-md-2 col-lg-2 order_sum_col">
                        <div class="form-group has-feedback">
                            <label for="DateTo" class="control-label">Date To:</label>
                            <!-- <input type="text" id="DateTo" name="DateTo" class="form-control" placeholder="Date To"
                                [(ngModel)]="orderSearchCriteria.DateTo" style="cursor: pointer;" readonly required /> -->


                            <div class="input-group">
                                <input class="form-control" id="DateTo" name="DateTo" [(ngModel)]="DateTo" [maxDate]="maxDate" [minDate]="DateFrom" (click)="dateTo.toggle()" ngbDatepicker #dateTo="ngbDatepicker" style="cursor: pointer;" readonly required>
                                <!-- <button class="btn btn-outline-secondary calendar" (click)="dateTo.toggle()"
                                    type="button"> -->
                                <i (click)="dateTo.toggle()" class="fa fa-calendar " aria-hidden="true" style="position: absolute;right: 6px;top: 5px;z-index: 9;"></i>

                                <!-- </button> -->

                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-4 col-md-2 col-lg-2 order_sum_col">
                        <div class="form-group has-feedback">
                            <label for="CustomerName" class="control-label">Search By Customer Name</label>
                            <input type="text" [(ngModel)]="orderSearchCriteria.CustomerName" name="CustomerName" class="form-control" placeholder="Search By Customer Name" />
                        </div>
                    </div>
                    <div class="col-12 col-sm-4 col-md-2 col-lg-2 order_sum_col">
                        <div class="form-group">
                            <label class="control-label">Order Status:</label>
                            <select *ngIf="orders" [(ngModel)]="orderSearchCriteria.OrderStatusId" name="orderStatus" class="form-control">
                                <option value="" style="display: none">--- Please Select ---</option>
                                <option *ngFor="let orderStatus of orders.OrderStatuses" [value]="orderStatus.Id">
                                    {{orderStatus.Name}}</option>

                            </select>
                        </div>
                    </div>
                    <div class="ccol-12 col-sm-8 col-md-4 col-lg-4 order_sum_col_">
                        <div class="form-group orders_sum_top ">
                            <div class="pull-right">
                                <button type="submit" class="btn btn-primary mr-1">Search</button>
                                <button type="button" (click)="cancelSearch()" class="btn btn-default">Clear</button>
                            </div>
                        </div>

                    </div>
                </div>
            </form>
        </div>
    </fieldset>

    <div class="row" *ngIf="orders">
        <div class="col-sm-12" *ngIf="orders?.PaginatedResult?.TotalRecords > 0">
            <div class="toatal-recode">Total Records:{{orders.PaginatedResult.TotalRecords}}</div>
        </div>
    </div>

    <fieldset class="scheduler-border clearfix">
        <legend class="scheduler-border">Orders List</legend>

        <div class="panel_table">
            <div class="panel panel-default ">
                <div class="table-responsive pull-left max-width margin-top-10">
                    <table class="table table-bordered table-striped">
                        <thead class="tableHeader">
                            <tr>

                                <th>Order Date </th>
                                <th>City </th>
                                <th>Customer </th>
                                <th>Customer Phone</th>
                                <th>No. of Items </th>
                                <th>Comforter</th>
                                <th>Blanket</th>
                                <th>Tablecloth</th>
                                <th>Order Status </th>
                                <th>Remarks </th>
                                <th>Actions </th>
                                <th>Cancelled By</th>
                                <th>Order#</th>
                            </tr>
                        </thead>
                        <tbody *ngIf="tableData">
                            <tr *ngFor="let mod of orders.Orders">
                                <td>{{mod.OrderDate | date:'MM/dd/yyyy'}}</td>
                                <td>{{mod.City}}</td>
                                <td class="hyperlink_name"><a (click)="getCustomerProfile(mod.CustomerId)">{{mod.CustomerName}}</a></td>
                                <td>{{mod.CustomerPhoneNo}}</td>
                                <td>{{mod.Items}}</td>
                                <td>{{mod.Comforter}}</td>
                                <td>{{mod.Blanket}}</td>
                                <td>{{mod.TableCloth}}</td>
                                <td>{{mod.OrderStatus}}</td>
                                <td>{{mod.Instructions}}</td>
                                <!-- <td>
                                    <a style="border: none ; background:none ; color:black"
                                        (click)="getOrderCancelReason(orderCancel, mod)">
                                        <i [ngClass]="mod.OrderStatusId == 80 ? 'fa fa-opencart' : mod.OrderStatusId == 10 ? 'fa fa-ban' : ''"
                                        title="{{mod.OrderStatusId == 80 ? 'Reopen' : mod.OrderStatusId == 10 ? 'Cancel' : ''}}"></i>
                                    </a>
                                    &nbsp;
                                    <a style="border: none ; background:none ; color:black" (click)="getCustomerCard(getCard, mod.CustomerId)"><i class="fa fa-credit-card-alt" title="Assign Card" aria-hidden="true"></i></a>
                                </td> -->
                                <td>
                                    <a style="border: none ; background:none ; color:red" (click)="getOrderCancelReason(orderCancel, mod)">{{(mod.OrderStatusId == 80) ?
                                        'Reopen Order' : ((mod.OrderStatusId == 10 ) ? 'Cancel Order' : '')}}</a>
                                    <!-- <span style="font-weight: bold; color: black;">{{((mod.OrderStatusId == 80) || (mod.OrderStatusId == 10 ) ? ' | ' : ''}}</span> -->
                                    <a *ngIf="mod.OrderStatusId == 53" style="border: none ; background:none ; color:red" (click)="getCustomerCard(getCard, mod)">Assign New Card</a>
                                </td>
                                <td>{{mod.CancelledBy}}</td>
                                <td>{{mod.OrderNoStr}}</td>


                            </tr>

                        </tbody>
                    </table>
                    <div *ngIf="orders?.PaginatedResult?.TotalRecords > 10" style="float: right;">
                        <ngb-pagination [(page)]="page" [maxSize]="10" [collectionSize]="orders?.PaginatedResult?.TotalRecords" [ellipses]="true" [boundaryLinks]="true" (pageChange)="getOrders($event)">
                        </ngb-pagination>
                    </div>
                </div>
            </div>
        </div>
    </fieldset>



</div>

<ng-template #orderCancel let-modal>
    <div class="modal-header modal-cencel">
        <h4 class="modal-title cancel_order_popup_heading">Select Reason for Cancel Order</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true" class="close_btn_popup">&times;</span>
        </button>
    </div>
    <div class=" modal_col field modal-cencel">
        <div class="modal-body class-of-dropdown pad_top_20 modal-cencel ">
            <!-- <p>One fine body&hellip;</p> -->
            <form #orderCancelForm="ngForm">
                <select [(ngModel)]="orderSearchCriteria.CancelReasonId" name="cancelReason" class="form-control" required>
                <option disabled  value=0>--- Please Select ---</option>
                <option *ngFor="let orderCancelReason of OrderCancelReason" [value]="orderCancelReason.Id" required>
                    {{orderCancelReason.Name}}</option>
            </select>

                <button type="button" class="btn btn-primary popup_orderCancel" [disabled]="!orderCancelForm.valid" (click)="modal.close('Close click')">Ok</button>
            </form>
            <br>
        </div>
        <br>
    </div>

</ng-template>

<ng-template #getCard let-modal>
    <div class="modal-header modal-cencel">
        <h4 class="modal-title cancel_order_popup_heading">Select card for this order</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true" class="close_btn_popup">&times;</span>
        </button>
    </div>
    <div class=" modal_col field modal-cencel">
        <div class="modal-body class-of-dropdown pad_top_20 modal-cencel ">
            <!-- <p>One fine body&hellip;</p> -->
            <select [(ngModel)]="cardId" name="CardDetails" class="form-control" required>
                <!-- <option disabled  value=0>--- Please Select ---</option> -->
                <option *ngFor="let card of cardList" [value]="card.ID" required>
                    {{card.CardDetails}}</option>
            </select>

            <button type="button" class="btn btn-primary popup_orderCancel" (click)="setDefaultCard()">Ok</button>
            <br>
        </div>
        <br>
    </div>

</ng-template>